import { render, staticRenderFns } from "./TypeEntrepriseEdit.vue?vue&type=template&id=2a2b806a&"
import script from "./TypeEntrepriseEdit.vue?vue&type=script&lang=js&"
export * from "./TypeEntrepriseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports